import { render, staticRenderFns } from "./CardReserve.vue?vue&type=template&id=5b456869&"
import script from "./CardReserve.vue?vue&type=script&lang=js&"
export * from "./CardReserve.vue?vue&type=script&lang=js&"
import style0 from "./CardReserve.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default})
